function toSnakeCase(str) {
  if (!str) return '';

  return str
    .toLowerCase() // Converte para minúsculas
    .replace(/\s+/g, '_'); // Substitui espaços por "_"
}

export { toSnakeCase };
